<div class="flex gap-2 items-center" [class.flex-row-reverse]="isRTL()">
  @if(this.lineUpPlayer().Number) {
  <span
    class="flex-shrink-0 w-5 font-roboto-600 text-16 text-grey-2"
    [class.text-end]="isRTL()"
    >{{ this.lineUpPlayer().Number }}</span
  >
  }
  <img
    alt="photo"
    class="flex-shrink-0 w-[30px] h-[30px] max-sm:w-[26px] max-sm:h-[26px] rounded-full border border-solid border-grey-15"
    [src]="this.getImageUrl()"
  />
  <span
    class="font-roboto-600 text-14 max-sm:text-10 truncate whitespace-nowrap overflow-hidden text-ellipsis flex-grow w-0"
    [class.text-end]="isRTL()"
  >
    {{ this.getPlayerName() }}
  </span>
</div>
